module.exports = __webpack_public_path__ + "static/media/ONT.6bc3f20b.svg";